// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__KD78J","MasculineText":"List_MasculineText__1ogJ_","FeminineText":"List_FeminineText__2Bsm_"};